<template>
	<div class="set-visiting-page page-bg">
		<van-form @submit="onSubmit">
			<!-- 基本信息 -->
			<cate-step-card
				style="padding-top: 0px; background-color: #f4f6f9"
				title="邀请函信息"
			></cate-step-card>
			<div class="box">
				<van-field
					v-model="info.userName"
					
					name="name"
					placeholder="请输入邀请人姓名"
					v-if="templateDetail.showName==='0'"
				/>
				<van-field
					v-model="info.mobile"
					
					name="phone"
					placeholder="请输入邀请人电话"
					v-if="templateDetail.showPhone==='0'"
				/>
				<!-- <van-field
					v-model="templateName"
					label="模板"
					name="templateId"
					placeholder="请选择名片模板"
					readonly
					is-link
					clickable
					@click="showTemplatePicker = true"
				/> -->
				<van-field
					v-model="info.postName"
					maxlength="19"
					name="name"
					placeholder="请输入邀请人职务"
					v-if="templateDetail.showPost==='0'"
				/>
				<van-field
					v-model="info.introduce"
					name="introduce"
					autosize
					maxlength="122"
					type="textarea"
					placeholder="请输入邀请函的介绍"
					v-if="templateDetail.showDesc==='0'"
				/>
				<van-field
					v-model="info.label"
					maxlength="28"
					name="name"
					placeholder="请输入邀请函标签"
					v-if="templateDetail.showTags==='0'"
				/>
				<van-field
					v-model="info.address"
					maxlength="28"
					name="address"
					placeholder="请输入邀请函地址"
					v-if="templateDetail.showAddress==='0'"
				/>

			</div>

			<div style="margin: 30px 0">
				<van-button block type="info" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>
		<!-- <van-popup
			v-model="showTemplatePicker"
			get-container="#app"
			position="bottom"
		>
			<van-picker
				ref="picker"
				title="选择名片模板"
				show-toolbar
				:default-index="selectIndex"
				:columns="showTemplateList"
				@confirm="confirmTemplate"
				@cancel="showTemplatePicker = false"
			/>
		</van-popup> -->
	</div>
</template>

<script>
import cateStepCard from '@/components/cate-step-card'
import { Notify } from 'vant'
export default {
	components: { cateStepCard },
	data() {
		return {
			info: {
				userName:"",
				mobile:"邀你一起赚佣金",
				postName:"分销员推广计划",
				introduce:"",
				label:"订酒店、订机票、买门票、周边游、邮轮旅行......",
				address:"你想要的，我们都有！"
			},
			showTemplatePicker: false,
			selectIndex: 0,
			templateList: [],
			templateDetail:{}
		}
	},
	computed: {
		showTemplateList() {
			return this.templateList.map((res) => {
				return res.name
			})
		},
	},
	mounted() {
		this.info = this.$route.query.info
		this.init()
	},
	methods: {
		init() {
			this.$API.market
				.getVisitingTempList()
				.then((res) => {
					this.templateList = res.data
					const a = res.data.filter((res) => {
						return res.status === '0'
					})
					if (a) {
						this.info.templateId = a[0].id
						if (this.info.templateId) {
							this.$API.market.fetchVisitDetail(this.info.templateId).then(res => {
								if (res.code === 200) {
									this.templateDetail = res.data;
								} else {
									this.templateDetail = {}
								}
							})
						}
					}
				})
				.catch((err) => {})
		},

		onSubmit(e) {
			let id = this.$store.state.userInfo_v2.user.userId
			var data = {
				userId: id,
				...this.info,
			}
			this.$API.market
				.setVisitingInfo(data)
				.then((res) => {
					this.$router.go(-1)
				})
				.catch((err) => {})
		},
		// confirmTemplate(e, index) {
		// 	this.selectIndex = index
		// 	this.templateName = e
		// 	this.info.templateId = this.templateList[index].id
		// 	this.showTemplatePicker = false
		// },
	},
}
</script>

<style lang="scss" scoped>
.set-visiting-page {
	box-sizing: border-box;
	padding: 16px;
	height: 100%;
	.van-form {
		background-color: #f4f6f9;
	}
	.box {
		background-color: white;
		border-radius: 4px;
		box-shadow: 0 6px 13px 0 rgba(0, 0, 0, 0.04);
		overflow: hidden;
	}
	.preview-cover {
		position: absolute;
		bottom: 0;
		box-sizing: border-box;
		width: 100%;
		padding: 4px;
		color: #fff;
		font-size: 12px;
		text-align: center;
		background: rgba(0, 0, 0, 0.3);
	}
	.upload-item {
		margin-top: 12px;
		position: relative;
		.upload-img {
			width: 150px;
			height: 95px;
		}
		.upload-place {
			width: 36px;
			height: 36px;
			position: absolute;
			left: 57px;
			top: 30px;
		}
		.upload-title {
			color: #999999;
			font-size: 12px;
			text-align: center;
		}
	}
}
</style>